/**
 * Onglets du hero « boucles ».
 * Un bouton par block. Cliquer synchronise d'un coup TOUTES les zones liées :
 * image de fond, texte, sous-titre des recos et grille produits.
 *
 * L'original utilisait 4 attributs différents (data-bg-id, data-content-id,
 * data-products-id, data-reco-subtitle-id) + 5 querySelectorAll + 5 boucles.
 * Ici une seule convention : `data-tab` sur les boutons, `data-panel` sur tout ce
 * qui doit suivre. Ajouter une zone liée ne demande plus une ligne de JS.
 */
class MaxHeroBoucle extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-tab]');
      if (tab) this.select(tab.dataset.tab);
    });

    const initial = this.querySelector('[data-tab]');
    if (initial) this.select(initial.dataset.tab);

    // Éditeur de thème : sélectionner un block affiche son onglet.
    this.addEventListener('shopify:block:select', (event) => {
      const tab = event.target.closest('[data-tab]');
      if (tab) this.select(tab.dataset.tab);
    });
  }

  select(id) {
    this.querySelectorAll('[data-tab]').forEach((tab) => {
      const isActive = tab.dataset.tab === id;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.querySelectorAll('[data-panel]').forEach((panel) => {
      panel.setAttribute('aria-hidden', panel.dataset.panel === id ? 'false' : 'true');
    });
  }
}

if (!customElements.get('max-hero-boucle')) customElements.define('max-hero-boucle', MaxHeroBoucle);
